import React from 'react';
import Navbar from '../global/Navbar';
import Footer from '../global/Footer';
import WorkWithUS from './WorkWithUS';
import MissionVision from './MissionVision';
import Approach from './CompanyApproach';
import CTA from './CTA';
import Newsletter from '../global/Newsletter';
import CompanyOwnership from './CompanyOwnership';
import Founder from './Founder';
import Leadership from './Leadership';
import LogoSlideshow from './LogoSlideshow';
import DeliveryBand from '../shared/DeliveryBand';
import SectionSurface, { PageFlow } from '../shared/SectionSurface';
import PageMeta from '../shared/PageMeta';
import { SHOW_COMPANY_PEOPLE } from '../../../content/siteFlags';

function About() {
  return (
    <div className="min-w-0 max-w-full">
      <PageMeta path="/company" />
      <Navbar />
      <PageFlow>
        <SectionSurface
          variant="wash"
          decor="none"
          underNav
          bleed="bottom"
          flowBottom
          overlap
        >
          <CTA />
        </SectionSurface>
        <SectionSurface variant="accent-enterprise" decor="rings" bleed="both" flowTop flowBottom overlap>
          <CompanyOwnership />
        </SectionSurface>
        <SectionSurface variant="wash" decor="contour" bleed="both" flowTop flowBottom overlap>
          <MissionVision />
        </SectionSurface>
        <SectionSurface variant="elevated" decor="wave" bleed="both" flowTop flowBottom overlap>
          <Approach />
        </SectionSurface>
        <SectionSurface variant="diagonal" decor="flow" bleed="both" flowTop flowBottom overlap>
          <WorkWithUS />
        </SectionSurface>
        {SHOW_COMPANY_PEOPLE ? (
          <SectionSurface variant="muted" decor="none" bleed="both" flowTop flowBottom overlap>
            <Founder />
            <Leadership />
          </SectionSurface>
        ) : null}
        <LogoSlideshow />
        <DeliveryBand id="delivery" compact variant="subtle" decor="dots" />
      </PageFlow>
      <Newsletter />
      <Footer />
    </div>
  );
}

export default About;
